import { useTranslation } from 'react-i18next';
import { useFeatureFlagContext } from 'shared/contexts/feature-flag-provider';
import { useIsOgpPlannerOrHigher } from 'ogp/hooks';
import { usePlanningContext } from '../../providers/planning-actions-provider';

export const useGetActions = (activeRoute?: string) => {
  const { allowCsvShiftImport } = useFeatureFlagContext();
  const { t } = useTranslation('ogp-screen-specific');
  const { setSidebarState, selectedShiftIds } = usePlanningContext();
  const userHasAccessToCreateShift = useIsOgpPlannerOrHigher();

  const primaryButtonAction = {
    label: t('planning.actions.create_shift'),
    onClick: () => setSidebarState('create'),
    disabled: !userHasAccessToCreateShift,
  };

  const actions = [
    ...(allowCsvShiftImport
      ? [
          {
            label: t('planning.actions.bulk_import_shifts'),
            onClick: () => setSidebarState('bulk-shift-creation'),
            disabled: !userHasAccessToCreateShift,
            subLabel: t('planning.actions.max_row_sub_label'),
          },
        ]
      : []),
    ...(activeRoute === 'table'
      ? [
          {
            label: t('planning.actions.forward_to_partners'),
            onClick: () => setSidebarState('bulk-forward'),
            disabled: selectedShiftIds && selectedShiftIds.length === 0,
          },
          {
            label: t('planning.actions.edit_shifts'),
            onClick: () => setSidebarState('bulk-edit'),
            disabled: selectedShiftIds && selectedShiftIds.length === 0,
          },
          {
            label: t('planning.actions.archive_shifts'),
            onClick: () => setSidebarState('bulk-archive'),
            disabled: selectedShiftIds && selectedShiftIds.length === 0,
          },
        ]
      : []),
  ];

  return { actions, primaryButtonAction };
};
